import { render, staticRenderFns } from "./BannerSettingEdit.vue?vue&type=template&id=40d79303&scoped=true"
import script from "./BannerSettingEdit.vue?vue&type=script&lang=js"
export * from "./BannerSettingEdit.vue?vue&type=script&lang=js"
import style0 from "./BannerSettingEdit.vue?vue&type=style&index=0&id=40d79303&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d79303",
  null
  
)

export default component.exports